import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2, AlertTriangle } from "lucide-react";

export function ConfirmDialog({ confirm, onClose }) {
  const [busy, setBusy] = useState(false);
  if (!confirm) return null;
  const run = async () => {
    setBusy(true);
    try { await confirm.onConfirm(); onClose(); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {confirm.danger && <AlertTriangle className="text-rose-500" size={20} />}
            {confirm.title}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">{confirm.description}</p>
        <div className="mt-5 flex justify-end gap-3">
          <button onClick={onClose} data-testid="confirm-cancel-btn" className="rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-600 tap-shrink">
            Cancel
          </button>
          <button
            onClick={run} disabled={busy} data-testid="confirm-action-btn"
            className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold text-white tap-shrink disabled:opacity-60 ${confirm.danger ? "bg-rose-600 hover:bg-rose-700" : "bg-[#0B192C] hover:bg-[#1E3E62]"}`}
          >
            {busy ? <Loader2 className="animate-spin" size={16} /> : (confirm.confirmLabel || "Confirm")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
